import { render } from "./EnquiryAssign.vue?vue&type=template&id=192dfb5c"
import script from "./EnquiryAssign.vue?vue&type=script&lang=js"
export * from "./EnquiryAssign.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__